import { render, staticRenderFns } from "./FormWrapperLayout.vue?vue&type=template&id=3a18ce2c&"
import script from "./FormWrapperLayout.vue?vue&type=script&lang=js&"
export * from "./FormWrapperLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports